import React from 'react';
import { Toast, TOAST_POSITIONS, TOAST_VARIANTS, TOAST_VISIBILITY_DURATIONS } from 'cdk-radial';

const Notification = ({content, customStyle, variant, actions, onDismiss}) => {

    let toastVariant =  {
        positive: TOAST_VARIANTS.POSITIVE,
        negative: TOAST_VARIANTS.NEGATIVE,
        neutral: TOAST_VARIANTS.neutral,
        warning: TOAST_VARIANTS.WARNING
    }

    return (
        <Toast 
            content={content}
            position={TOAST_POSITIONS.FIXED}
            style={customStyle}
            variant={toastVariant[variant]}
            visibilityDuration={TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS}
            actions={actions}
            onVisibilityDurationEnd={onDismiss}
            actions={[{
                onClick: () => {
                  onDismiss();
                },
                text: 'Dismiss'
              }]}
        />
    )
}

export default React.memo(Notification);